<template>
    <el-container style="height: 100%;">
        <el-header style="padding: 0px;height: 80px;">
            <commin-header></commin-header>
        </el-header>
        <el-container  style="height: calc(100% - 80px);">
            <!-- 265px -->
            <el-aside :width="isCollapse == false ? '265px' : ''">
                <!-- <div class="collapse_box" @click="collapse">
                    <i class="iconfont icon-kongzhitai"></i>
                </div> -->
                <el-menu 
                    :default-active="this.$route.path"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose"
                    style="height: calc(100% - 0px);border-right: 0px;"
                    background-color="#1b1833"
                    text-color="#fff"
                    :router="true"
                    active-text-color="#ffd04b"
                    :collapse="isCollapse">
                    <!-- 引入组件 -->
                    <menu-tree :menuData="menuData"></menu-tree>
                </el-menu>
            </el-aside>
            <el-main style="padding: 0px;">
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import comminHeader from '@/components/comminHeader'
import MenuTree from '@/components/MenuTree'
export default {
    components: {
        comminHeader,
        MenuTree
    },
    data() {
        return {
            isCollapse: false,
            menuData: []
        }
    },
    computed: {
        menuList() {
            return this.$store.state.routers.routers;  
        },
    },
    mounted() {

    },
    created() {
        this.getListMenu()
    },
    methods: {
        getListMenu() {
            this.$http.get("../../static/menuData.json").then(response => {
                if (response.data.code == 200) {
                    this.menuData = response.data.data.menuList
                }
            })
        },
        collapse() {
            this.isCollapse = !this.isCollapse
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        changeMenu(e){
            window.sessionStorage.setItem('activePath',e)
            // console.log(window.sessionStorage.getItem('activePath'))		   
        },
    }
}
</script>

<style lang="scss" scoped>
.el-header{
    background-color: #ffffff;
    color: #333;
    background-color: azure;
}
.el-aside {
    height: 100%;
    color: #333;
    box-sizing: border-box;
}
.el-main {
    height: 100%;
    color: #333;
    overflow: hidden;
}
body > .el-container {
    margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
    line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
    line-height: 320px;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
// div >>> .el-menu-item * {
//     font-size: 15px !important;
// }
.collapse_box {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: #1b1833;
    color: #ffffff;
    i {
        font-size: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/layout.vue